// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1k7lX","boxTitle":"Qualiphy_boxTitle__3b4pa","box":"Qualiphy_box__aqQJL","toggleWrap":"Qualiphy_toggleWrap__5bwpO"};